import { useState, useEffect } from 'react';
import { Popover } from '@headlessui/react';
import DynamicIcon from './dynamic-icon';

const NotificationPopover = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [hasSeen, setHasSeen] = useState(() => {
    return sessionStorage.getItem('hasSeenNotification') === 'true';
  });
  const [isVisible, setIsVisible] = useState(() => !hasSeen);

  const handleClose = () => {
    setIsVisible(false);
    setHasSeen(true);
    sessionStorage.setItem('hasSeenNotification', 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Popover className="relative">
      {/* <div
        className="relative"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Popover.Button
          onClick={handleClose}
          className="flex items-center rounded-full bg-white-50 dark:bg-grey-600 custom-shadow p-[14.8px] h-[50px] w-[50px] outline-none"
        >
          <div className="relative w-[21px] h-[21px]">
            <div className={`absolute transition-opacity duration-200 ${isHovered ? 'opacity-0' : 'opacity-100'}`}>
              <DynamicIcon name="bell" size={21} color="custom-text-grey-600" />
            </div>
            <div className={`absolute transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
              <DynamicIcon name="x" size={21} color="custom-text-grey-600" />
            </div>
          </div>
        </Popover.Button>
      </div> */}

      {isOpen && (
        <Popover.Panel static className="absolute bottom-0 right-[-40px] lg:right-0 w-[330px] rounded-[8px] border-[1px] custom-border-grey-50 bg-white-50 dark:bg-grey-600 p-[10px] custom-shadow transition-opacity duration-200">
          <div className="relative grid gap-[4px]">
            <div className="flex justify-between items-start">
              <span className="custom-text-grey-800 text-[14px] poppins-medium leading-[21px]">
                Bienvenue sur Workpeg !
              </span>
              <DynamicIcon name='x' size={15} color='custom-text-grey-800 cursor-pointer' onClick={()=>setIsOpen(false)} />
            </div>
            <span className="custom-text-grey-800 text-[14px] poppins-regular leading-[21px] max-w-[280px]">
              Bientôt, notre système prendra en charge le français. Merci pour votre patience !
            </span>
          </div>
          {/* <div className="w-[2px] h-[12px] bg-white-50 dark:bg-grey-600 absolute right-[24px] bottom-[-13px] custom-shadow"></div> */}
        </Popover.Panel>
      )}
    </Popover>
  );
};

export default NotificationPopover;